<template>
    <form @keydown.enter.prevent="submit">
        <div class="form-row align-items-end">
            <div class="col-md-3" v-if="enableKeyword">
                <form-input :label="Lang.get('messages.keyword')" name="keyword" :model="model" prop="keyword" />
            </div>

            <div class="col-md-3" v-if="enableSubmit">
                <div class="form-group">
                    <button type="button" @click="submit" class="btn btn-primary btn-sm form-control"
                        style="height: 38px;">
                        {{ Lang.get('messages.search') }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'KeywordFilter',
    emits: ['submit'],
    props: {
        model: {
            type: Object,
            required: true
        },
        enableKeyword: {
            type: Boolean,
            default: true
        },
        enableSubmit: {
            type: Boolean,
            default: true
        },
        keyword: {
            type: String,
            default: 'global.search'
        }
    },
    methods: {
        submit() {
            this.$emit('submit');
        }
    }
};
</script>
